import { SiteService } from '../../../../../../../services/site.service';
import {
    Component,
    OnInit,
    ViewEncapsulation,
    EventEmitter,
    Input,
    Output
} from '@angular/core';
import { Helpers } from '../../../../../../../helpers';
import { Router } from '@angular/router';
import { BaseComponent } from '../../../../base.component';

@Component({
    selector: 'app-list-site',
    templateUrl: './list-site.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ListSiteComponent extends BaseComponent implements OnInit {
    sites: any;
    querySiteId: string;
    path: string;
    private _publisherId: string;
    get publisherId(): string {
        return this._publisherId;
    }
    @Input()
    set publisherId(publisherId: string) {
        this._publisherId = publisherId;
        this.getSites();
    }

    @Input() selectedSiteId: string;
    @Input() routePath: string;
    @Input() publisherName: string;
    @Output() siteChange: EventEmitter<any> = new EventEmitter<any>();

    constructor(private siteService: SiteService, private router: Router) {
        super();
        this.path = Helpers.getPath();
    }

    ngOnInit() { }

    getSites() {
        Helpers.setLoading(true);
        this.siteService.list({ filterId: this.publisherId }).subscribe(res => {
            this.sites = res.data;
            if (this.sites.length > 0) {
                this.onSelect(
                    this.selectedSiteId
                        ? this.selectedSiteId
                        : this.sites.length > 0
                            ? this.sites[0].id
                            : null
                );
            }
            Helpers.setLoading(false);
        });
    }

    onSelect(siteId): void {
        let site = this.sites[0];
        if (siteId != null || siteId != this.sites[0].id) {
            this.sites.forEach(item => {
                if (item.id == siteId) {
                    site = item;
                }
            });
        }
        this.selectedSiteId = site.id;
        this.siteChange.emit({ id: site.id, name: site.title });
    }

    onClickCreateSite() {
        this.router.navigate(['/' + this.path + '/inventory/site/create'], {
            queryParams: {
                publisherId: this.publisherId,
                publisherName: this.publisherName,
                returnUrl: this.routePath
            }
        });
    }

    deleteSite(siteId: string) {
        this.swalService.confirmDelete().then(res => {
            if (res.value) {
                Helpers.setLoading(true);
                this.siteService.delete(siteId).subscribe(() => {
                    Helpers.setLoading(false);
                    this.getSites();
                    this.swalService.successDelete();
                    this.selectedSiteId = null;
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/shared/inventory/site/list-site/list-site.component.ts